import { warningColor } from 'assets/jss/material-dashboard-pro-react';

const contactCustomerCare = (theme) => ({
	contactCustomerCare: {
		display: 'flex',
		justifyContent: 'center',
		flexDirection: 'row',
		margin: '24px 0 0 0',
		[theme.breakpoints.down('xs')]: {
			flexWrap: 'wrap',
			justifyContent: 'flex-start',
		},
	},
	contactCustomerCareIconContainer: {
		margin: '0 12px 24px 0',
		[theme.breakpoints.down('xs')]: {
			padding: '0 0 0 0',
			margin: 0,
			width: '100%',
		},
	},
	contactCustomerCareContainer: {
		flexGrow: 1,
		marginLeft: '12px',
		[theme.breakpoints.down('xs')]: {
			margin: 0,
			width: '100%',
		},
	},
	cardBody: {
		margin: 0,
		padding: '24px 24px 48px 24px',
		[theme.breakpoints.down('xs')]: {
			width: '100%',
			padding: 16,
		},
	},
	card: {
		marginTop: '0px',
		marginBottom: '0px',
		[theme.breakpoints.down('xs')]: {
			width: '100%',
		},
	},
	iconContainer: {
		padding: 40,
		textAlign: 'center',
		[theme.breakpoints.down('xs')]: {
			padding: '16px 0 0 16px',
			margin: 0,
			textAlign: 'left',
		},
	},
	icon: {
		height: 56,
		width: 56,
		[theme.breakpoints.down('xs')]: {
			height: 48,
			width: 48,
		},
	},
	contactIcon: {
		color: warningColor[0],
	},
	supportIcon: {
		height: 40,
		width: 40,
		[theme.breakpoints.down('xs')]: {
			height: 24,
			width: 24,
		},
	},
	contactCustomerCareFirstSection: {
		maxWidth: 370,
	},
	simplyDial: {
		padding: '16px 0 7px 0',
		maxWidth: 536,
	},
	callCentreWrapper: {
		margin: '13px 0 9px 4px',
		[theme.breakpoints.down('xs')]: {
			margin: '13px 0 9px 0',
		},
	},
	callCentre: {
		display: 'flex',
		'& > *': {
			display: 'inline-block',
		},
		'& > *:nth-child(2)': {
			paddingLeft: 16,
			marginLeft: 0,
		},
	},
	customerServiceWrapper: {
		maxWidth: 355,
	},
	calls: {
		paddingLeft: 56,
		paddingTop: 16,
		[theme.breakpoints.down('xs')]: {
			paddingLeft: 40,
		},
	},
});

export default contactCustomerCare;
